import SupportMailForm from "../components/SupportMailForm";

export default function Contact() {
  return (
    <article>
      <h1>Contact</h1>
      <p className="lead">A quiet note is enough. We will reply when we can sit with it.</p>
      <SupportMailForm />
    </article>
  );
}
